module.exports = __webpack_public_path__ + "img/logo-type.5571326.png";